export enum AclResource {
  WorkspaceSettings = 'workspaceSettings',
  FlowDefinitionCreate = 'flowDefinitionCreate',
  FlowDefinitionEdit = 'flowDefinitionEdit',
  FlowInstanceList = 'flowInstanceList',
  FlowInstanceCreate = 'flowInstanceCreate',
  FlowInstanceShare = 'flowInstanceShare',
  FlowInstanceAiEvaluate = 'flowInstanceAiEvaluate',
}
